/**
 * Abuse-block query + mutation layer. The list keys under `["venue", venueId, "abuse-blocks"]` so the
 * shell's `eventQueryKeyMap` (`abuse.*` → `["venue", venueId, "abuse-blocks"]`) invalidates it when a
 * block is raised or cleared. Clearing refetches on settle so the panel drops the row immediately.
 */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { abuseApi, type AbuseBlockPageResponse } from "./abuseApi";

export const abuseKeys = {
  list: (venueId: string) => ["venue", venueId, "abuse-blocks", "active"] as const,
};

export function useAbuseBlocks(venueId: string) {
  return useQuery<AbuseBlockPageResponse>({
    queryKey: abuseKeys.list(venueId),
    queryFn: ({ signal }) => abuseApi.list(venueId, signal),
    staleTime: 15_000,
  });
}

export function useClearAbuseBlock(venueId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (blockId: string) => abuseApi.clear(venueId, blockId),
    onSettled: () => qc.invalidateQueries({ queryKey: abuseKeys.list(venueId) }),
  });
}
